import { render, staticRenderFns } from "./Controll.vue?vue&type=template&id=88a4cc92&scoped=true&"
import script from "./Controll.vue?vue&type=script&lang=js&"
export * from "./Controll.vue?vue&type=script&lang=js&"
import style0 from "./Controll.vue?vue&type=style&index=0&id=88a4cc92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a4cc92",
  null
  
)

export default component.exports